<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'masterdata.cutting.dialog.httperror' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ 'masterdata.cutting.colors.color-combination' | translate }}</h1>

	<mat-dialog-content style="padding-top: 20px">
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.colors.combination' | translate }}</mat-label>
			<input maxlength="250" matInput formControlName="colors" />
		</mat-form-field>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'masterdata.cutting.dialog.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">{{ 'masterdata.cutting.dialog.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
